<template>
  <div class="about">

    <div class="p-2 ml-2 bg-light gothic fontSizeDot9 border-top border-bottom">
      <router-link :to="{ name: 'tinkHome' }" custom v-slot="{ navigate }">
        <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
          처음
        </span>  
      </router-link>
      &gt;
      <b-dropdown text="IoT 키트" size="sm" role="menu" toggle-class="pl-2 pr-2 pt-dot1 pb-dot1">
        <b-dropdown-item :to="{ name: 'tinkAbout' }">
          Tinkable 소개
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkAboutKit' }" :active="true">
          IoT 키트
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkAboutCore' }">
          Core 프로그램
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkAboutData' }">
          Data 서비스
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkTos' }">
          서비스 약관
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkPrivacy' }">
          개인정보 처리방침
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <h1 class="documentTitle" v-if="!presentationMode">
      Tinkable IoT 키트 소개
    </h1>

    <div class="contentBody">

      <h2><a name="kit">개요</a></h2>
      <div class="extra gothic">
        <ul>
          <li>처음 사용자용 매뉴얼 PDF</li>
          <li>V3.1 소개 PDF 다운로드</li>
          <li>V3.1 매뉴얼 PDF 다운로드</li>
          <li>V3.1 소개 블로그 페이지</li>
          <li>V3.1 소개 유튜브 동영상</li>
        </ul>
      </div>
      <p>Tinkable IoT 키트는 센서를 바로 꽂아서 사용할 수 있도록 만든 IoT 제품입니다.</p>

      <h2><a name="kit">목표</a></h2>
      <ul>
        <li>빵판없이</li>
        <li>납땜없이</li>
      </ul>

      <h2><a name="kit">Tinkable IoT 키트 V4</a></h2>
      <ul>
        <li>현재 개발 중에 있습니다. </li>
        <li>키워드: 2021-09, ESP32, MQTT(Google IoT Core), built-in battery, built-in RTC, bluetooth, stability, massive...</li>
      </ul>

      <h2><a name="kit">Tinkable IoT 키트 V3.1</a></h2>
      <p class="extra">
        V3.1 이미지
      </p>
      <p>Tinkable IoT 키트는 센서를 바로 꽂아서 사용할 수 있도록 만든 IoT 제품입니다.</p>

      <h2><a name="kit">IoT 키트가 지원하는 센서</a></h2>
      <p>Tinkable IoT 키트는 센서를 바로 꽂아서 사용할 수 있도록 만든 IoT 제품입니다.</p>
      <ul>
        <li>BME280</li>
      </ul>

      <h2><a name="kit">IoT 키트가 지원하는 액츄에이터</a></h2>
      <p>Tinkable IoT 키트는 센서를 바로 꽂아서 사용할 수 있도록 만든 IoT 제품입니다.</p>
      <ul>
        <li>0.96인치 OLED</li>
      </ul>

      <h2><a name="kit">Tinkable IoT 키트 V2 (I2C 허브)</a></h2>
      <p class="extra">
        V2 이미지
      </p>
      <p>Tinkable IoT 키트는 센서를 바로 꽂아서 사용할 수 있도록 만든 IoT 제품입니다.</p>

      <h2><a name="kit">Tinkable IoT 키트 V1</a></h2>
      <p>Tinkable IoT 키트는 센서를 바로 꽂아서 사용할 수 있도록 만든 IoT 제품입니다.</p>
    </div>
  </div>
</template>
<script>
  import { mapState } from "vuex"
  import { mapSetter } from "@/plugins/vuexUtils.js"
  export default {
    name: "tinkAbout",
    computed: {
      ...mapSetter(
        mapState({
          presentationMode:  state => state.presentationMode,
        })
      )
    },
    mounted() {
      window.document.body.scrollIntoView(true);
    },
  }
</script>
